import {
    ATTR_OBJ_ID,
    ATTR_OBJ_STATE,
    ATTR_PARENT_OBS,
    ATTR_SORT_ORDER_I,
    currentTimeMs,
    OBJ_STATE_TO_DEL,
    PROS_REPLACE_BY_LIST_ID,
    ATTR_OBJ_TYPE,
    OBJ_TYPE_LST,
    STR_NO_VALUE,
    ATTR_AWS_PROJECT_ID,
    getActiveProject,
    getGlobalRef,
    getValidAttr,
    ATTR_COPY_FROM_REPORT,
    isReportType,
    isObservation, OBJ_TYPE_ITM_TITLE, isTitle, MINIMUM_SORT_ORDER_SPACING, OBJ_TYPE_ITM_OBS,
} from "./ProsConnect";
import {pollChanges} from "./ProjectLoader"
import * as prosConnect from "./ProsConnect";

const FILTER_DELAY_RECURSIVE_DRAGS_MS = 200;

let copyMoveManager;

// Keep this for testing purposes
// let prevValidityCheckId;

// singleton
export function getCopyMoveManager() {
    if (!copyMoveManager) {
        copyMoveManager = new CopyMoveManager();
    }
    return copyMoveManager;
}

function adjustListSortOrders(changeList, objs) {
    if (!Array.isArray(objs)) {
        return
    }
    let prevSo = 0
    for (let obj of objs) {
        if (obj[ATTR_SORT_ORDER_I] - prevSo < MINIMUM_SORT_ORDER_SPACING) {
            obj[ATTR_SORT_ORDER_I] = prevSo + MINIMUM_SORT_ORDER_SPACING
            let attrChanges = {
                [ATTR_SORT_ORDER_I]: obj[ATTR_SORT_ORDER_I],
            }
            changeList.push(prosConnect.getChangeObj(obj, attrChanges))
        }
        prevSo = obj[ATTR_SORT_ORDER_I]
    }
}

class CopyMoveManager {
    constructor() {
        this.sourceObj = undefined;
        this.sourcePid = undefined;
        this.sourceReportItems = undefined;
        this.copyMode = false;
        this.moveMode = false;
        this.updateSortOrderList = [];
        this.otherWebPollTimer = null;
    }

    clear() {
        this.sourceObj = undefined;
        this.sourcePid = undefined;
        this.sourceReportItems = undefined;
        this.copyMode = false;
        this.moveMode = false;
        this.updateSortOrderList.length = 0;
    }

    ignoreCascadedObject() {
        let ignore = currentTimeMs() - this.markedTimeStampMs < FILTER_DELAY_RECURSIVE_DRAGS_MS;
        if (!ignore) {
            this.markedTimeStampMs = currentTimeMs();
        }
        return ignore;
    }

    markDrag(obj, altKey) {
        if (!obj || this.ignoreCascadedObject()) {
            return;
        }
        if (altKey) {
            this.markCopySource(obj);
        } else {
            this.markMoveSource(obj);
        }
    }

    async onDropped(obj, altKey) {
        if (!obj || this.ignoreCascadedObject()) {
            return
        }
        await this.fixReportSortOrderSpacing(obj, false)
        if (altKey) {
            return await this.awaitCopy(obj)
        }
        let checkSpacingAfterMove = await this.awaitMove(obj)
        if (checkSpacingAfterMove) {
            await this.fixReportSortOrderSpacing(obj, true)
        }
    }

    markMoveSource(obj) {
        this.clear();
        this.markSource(obj);
        this.moveMode = true;
        prosConnect.markGlobalRef(obj, false);
        this.triggerTimerForOtherWebSession(true);
    }

    markCopySource(obj) {
        this.clear();
        this.markSource(obj);
        this.copyMode = true;
        prosConnect.markGlobalRef(obj, true);
        this.triggerTimerForOtherWebSession(true);
    }

    markSource(obj) {
        this.sourceObj = obj;
        this.sourcePid = prosConnect.getActiveProject().getPid();
        if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST) {
            this.sourceReportItems = prosConnect.getActiveProject().getReportItems(obj);
        } else {
            this.sourceReportItems = undefined;
        }
    }

    isMoveMode() {
        if (!this.sourceObj) {
            this.clear();
            return prosConnect.getGlobalRefMode(false);
        }
        return this.moveMode;
    }

    isCopyMode() {
        if (!this.sourceObj) {
            this.clear();
            return prosConnect.getGlobalRefMode(true);
        }
        return this.copyMode;
    }

    isCopyOrMoveMode() {
        return this.isCopyMode() || this.isMoveMode()
    }

    isCopyOrMoveReportMode() {
        return (this.copyMode && this.sourceObj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST) ||
            (this.moveMode && this.sourcePid !== prosConnect.getActiveProject().getPid())
    }

    cancelOperations() {
        this.clear();
        prosConnect.markGlobalRef(undefined);
    }

    setRearrangeMode(newDragState) {
        this.dragState = newDragState
    }

    getRearrangeMode() {
        return this.dragState
    }

    onDragStart(ev, obj) {
        ev.stopPropagation()
        ev.nativeEvent.stopImmediatePropagation()
        // Needed by Firefox
        // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#dragdata
        ev.dataTransfer.setData('text','')
        // Note if dragging item from OBS this will be called "recursively" - ignore 2nd if happened very recently
        getCopyMoveManager().markDrag(obj, ev.altKey)
    }

    onDragOver(ev, target) {
        if (!this.isValidCopyMoveTarget(target)) {
            // Not allowed
            return
        }
        // This is to show "+ red add line" after element to indicate drop is allowed
        ev.target.classList.add('drop-indicator')
        // do not show this for parent element
        ev.stopPropagation()
        // This is to allow drop
        ev.preventDefault()
    }

    onDragLeave(ev) {
        ev.target.classList.remove('drop-indicator')
    }

    onDrop(ev, obj) {
        getCopyMoveManager().onDropped(obj, ev.altKey)
        ev.target.classList.remove('drop-indicator')
    }

    pollWebTransferCompleted() {
        if (prosConnect.isObservation(this.sourceObj)) {
            if (!prosConnect.getGlobalRef()) {
                // global transfer completed by another browser instance
                this.clear();
                pollChanges(true);
            }
        } else {
            this.triggerTimerForOtherWebSession(false);
        }
    }

    triggerTimerForOtherWebSession(start) {
        if (this.otherWebPollTimer) {
            clearInterval(this.otherWebPollTimer);
            this.otherWebPollTimer = null;
        }
        if (start) {
            this.otherWebPollTimer = setInterval(()=> this.pollWebTransferCompleted(), 1500);
        }
    }

    getSource() {
        if (this.sourceObj) {
            return this.sourceObj;
        }
        return prosConnect.getGlobalRef(false);
    }

    /*
    // Keep this for testing purposes
    isValidCopyMoveTarget(target) {
        if (!target?.obj_type || !target?.obj_id) {
            return false
        }
        let source = this.getSource()
        if (!source?.obj_type || !source?.obj_id) {
            return false
        }
        let mayDrop = this.isValidCopyMoveTarget2(target)
        if (prevValidityCheckId !== target.obj_id) {
            prevValidityCheckId = target.obj_id
            console.log("isValidCopyMoveTarget() target:", target.obj_type, target.text,
                "source:", source.obj_type, source.text, "-> mayDrop:", mayDrop)
        }
        return mayDrop
    }
    */

    /**
     * Check is marked source (dragged) can be dropped after or into target element
     * Use-cases
     *      1 - rearrange report list -> report is allowed only after another report
     *                  Dragging is not allowed for opened or numbered report
     *      2 - rearrange report root items
     *      3 - rearrange or copy OBS child items - same OBS
     *      4 - move or copy OBS child item to another OBS
     *      5 - move or copy OBS child item to root / after a title
     *      6 - move or copy root child item into OBS
     *      7 - move or copy root level child item after another child item or title
     *      8 - move or copy OBS after a title or child item - must be a last child item after a title !
     * @param target        Item for which check if is a valid target
     * @returns {boolean|*} true when is a valid target
     */
    isValidCopyMoveTarget(target) {
        let source = this.getSource()
        if (!source?.obj_type || !source?.obj_id) {
            // copy or move not started
            return false
        }
        if (!target?.obj_type || !target?.obj_id) {
            // Dragged target is not a prodect item
            return false
        }
        if (this.isMoveMode() && source[ATTR_OBJ_ID] === target[ATTR_OBJ_ID]) {
            // can not move to self
            return false
        }
        if (isReportType(source)) {
            // use-case 1: source is report - accept move/copy after another closed report that has no number yet
            return isReportType(target) && !target.ui_isOpen
        }
        if (isReportType(target)) {
            if (target.ui_isOpen) {
                // Allow drop to opened report only when it has no items yet
                return target.obsList.length < 1
            }
            // Do not allow dropping items to closed report
            return false
        }
        if (isObservation(target)) {
            // use-cases 3, 4, 6
            // report is handled above - here obs, title and child item i.e. any item in a report
            if (target.ui_isOpen) {
                // Opened OBS - allow drop only after OBS child item when have such
                // OBS can not be moved into another OBS
                return !target.obsObjList?.length && !isObservation(source) && !isTitle(source)
            }
            // After closed accept title or another OBS
            return isTitle(source) || (isObservation(source))
        }
        // target is a title, comment, picture or video which can be on root or inside an OBS
        // source is a title, OBS, comment, picture or video
        let isTargetRootLevelItem = isTitle(target) ||
            (getValidAttr(target, ATTR_PARENT_OBS, STR_NO_VALUE) === STR_NO_VALUE)
        if (isTargetRootLevelItem) {
            // Target is a root level comment or picture
            // todo use case 8 OBS should be allowed only after "last root element before another OBS or title
            return true
        }
        // use case 4, 6
        // accept a child item after OBS child item
        return !isTitle(source) && !isObservation(source)
    }

    isCopyMoveSource(item) {
        let source = this.getSource()
        return source && item[ATTR_OBJ_ID] === source[ATTR_OBJ_ID]
    }

    movingItemIntoObs(afterObj) {
        let srcObj = this.getSource()
        if (!srcObj || srcObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
            return false
        }
        return !prosConnect.isObservation(srcObj) && prosConnect.isObservation(afterObj)
    }

    async moveReport(afterObj) {
        let afterListId = prosConnect.getObjListId(afterObj);
        if (afterListId === this.sourceObj[ATTR_OBJ_ID]) {
            prosConnect.prosLog("Report move cancelled - report to same place");
            this.cancelOperations();
            return
        }
        let afterReport = prosConnect.getObjById(afterListId);
        if (!afterReport) {
            prosConnect.prosLogErr("Report move failed - integrity error");
            this.cancelOperations();
            return
        }
        let nextReport = getActiveProject().getNextReportAfter(afterListId);
        let newSort;
        if (!nextReport) {
            newSort = currentTimeMs();
        } else {
            newSort = (parseInt(nextReport[ATTR_SORT_ORDER_I]) + parseInt(afterReport[ATTR_SORT_ORDER_I])) / 2;
        }
        await prosConnect.getActiveProject().awaitUpdateItemAttrs(this.sourceObj, {[ATTR_SORT_ORDER_I]: newSort});
        this.cancelOperations();
    }

    async awaitMoveBetweenReports(afterObj) {
        // Moving between reports
        if (!prosConnect.isObservation(this.sourceObj)) {
            alert("Raporttien välillä voi siirtää vain kirjauksia");
            return;
        }
        let originalObs = this.sourceObj;
        let srcPid = originalObs.hasOwnProperty(ATTR_AWS_PROJECT_ID) ?
            originalObs[ATTR_AWS_PROJECT_ID] :
            this.sourcePid;
        delete(originalObs[ATTR_AWS_PROJECT_ID]);
        // move between reports..  1st copy
        await this.awaitCopy(afterObj, true);
        // and then remove originals
        originalObs[ATTR_AWS_PROJECT_ID] = srcPid;
        originalObs[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
        let objs = [originalObs];
        for (let i in originalObs.obsObjList) {
            let obj = originalObs.obsObjList[i];
            obj[ATTR_AWS_PROJECT_ID] = srcPid;
            obj[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
            objs.push(obj)
        }
        await prosConnect.getActiveProject().awaitUpdateMultipleItems(objs, true);
        this.cancelOperations();
    }

    awaitGlobalMove(afterObj) {
        this.sourceObj = prosConnect.getGlobalRef();
        prosConnect.prosLog("GLO transfer - move from other browser", this.sourceObj);
        this.awaitMoveBetweenReports(afterObj);
    }

    /**
     * Consolidate sort orders before each move and copy operation and fix if necessary
     * @param afterObj          After OBJ is a) report b) report root item or c) obs child item
     * @param triggerRefresh    After update using host response refresh UI
     * @returns {Promise<void>} No value returned - after promise been executed list sort orders have enough spacing
     */
    async fixReportSortOrderSpacing(afterObj, triggerRefresh) {
        let activeProject = prosConnect.getActiveProject()
        let sortOrderChanges = []

        if (prosConnect.isReportType(afterObj)) {
            // Rearranging reports
            let reports = activeProject.getReports(true)
            adjustListSortOrders(sortOrderChanges, reports)
        } else {
            let parentObsId = getValidAttr(afterObj, ATTR_PARENT_OBS, STR_NO_VALUE)
            if (parentObsId !== STR_NO_VALUE) {
                // Check spacing between OBS child items
                let childItems = activeProject.getObsChildren(afterObj[ATTR_PARENT_OBS])
                adjustListSortOrders(sortOrderChanges, childItems)
            }
            // Check spacing between report root items
            let reportId = prosConnect.getObjListIdFromItemId(afterObj[ATTR_OBJ_ID])
            let reportItems = activeProject.getReportItemsByReportId(reportId)
            adjustListSortOrders(sortOrderChanges, reportItems)
        }
        prosConnect.prosLog("Number of SO changes after checking spacing:", sortOrderChanges.length)
        if (sortOrderChanges.length > 0) {
            await activeProject.awaitUpdateMultipleItemsAttributes(sortOrderChanges, triggerRefresh)
        }
    }

    async awaitMove(afterObj) {
        let adjustSpacingAfterUpdate = false
        // console.log("MOVE pid:", this.sourcePid, ', obj:', this.sourceObj);
        // console.log("MOVE after", afterObj);
        if (!this.sourceObj) {
            prosConnect.prosLog("no local source marked - checking global ref")
            if (prosConnect.getGlobalRefMode(false)) {
                this.awaitGlobalMove(afterObj);
                return;
            }
        }
        if (!this.sourceObj) {
            // source not selected - happens when object does not support dragging
            prosConnect.prosLog("Source not marked - obj does not support dragging");
        } else if (this.sourceObj.obj_id === afterObj.obj_id) {
            // move after itself - cancel moving
            prosConnect.prosLog("Move/copy cancelled - same place");
        } else {
            if (prosConnect.isReportType(this.sourceObj)) {
                await this.moveReport(afterObj);
                return;
            }
            if (prosConnect.getObjListId(this.sourceObj) === prosConnect.getObjListId(afterObj)) {
                // move inside report => update sort order
                let needUpdate = false;
                if (prosConnect.isObservation(afterObj) || prosConnect.isTitle(afterObj)) {
                    // if destination is an OBS or TITLE clear it's parent to fix moving
                    // picture from OBS to next OBS that was raised from comment to an OBS
                    // ref bug #1.166
                    afterObj[ATTR_PARENT_OBS] = undefined
                }
                if(afterObj[ATTR_PARENT_OBS] !== this.sourceObj[ATTR_PARENT_OBS]) {
                    this.sourceObj[ATTR_PARENT_OBS] = afterObj[ATTR_PARENT_OBS];
                    needUpdate = true;
                }
                let activeProject = prosConnect.getActiveProject()
                let afterObjId = afterObj.obj_id;
                if (activeProject.getPrevObjId(this.sourceObj) !== afterObjId ||
                    this.sourceObj[ATTR_SORT_ORDER_I] === afterObj[ATTR_SORT_ORDER_I]) {
                    needUpdate = true;
                }
                if (!needUpdate) {
                    prosConnect.prosLog("Ignore moving to same place");
                } else {
                    let sortOrder = activeProject.getSortOrderAfter(this.sourceObj, afterObjId);
                    let changedItem = prosConnect.getChangeObj(this.sourceObj, {[ATTR_SORT_ORDER_I]: sortOrder})
                    let changes = [changedItem]
                    if (this.movingItemIntoObs(afterObj)) {
                        // Moving item inside OBS
                        changedItem[ATTR_PARENT_OBS] = afterObj.obj_id;
                    } else {
                        if (prosConnect.isObservation(this.sourceObj)) {
                            let itemChangedSortOrder = sortOrder
                            for (let itemInd in this.sourceObj.obsObjList) {
                                let item = this.sourceObj.obsObjList[itemInd];
                                itemChangedSortOrder += prosConnect.DEFAULT_SORT_ORDER_SPACING
                                let attrChanges = {
                                    [ATTR_SORT_ORDER_I]: itemChangedSortOrder,
                                    [ATTR_PARENT_OBS]: this.sourceObj.obj_id
                                }
                                changes.push(prosConnect.getChangeObj(item, attrChanges))
                            }
                        } else if (this.sourceObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
                            // move title - move comments and picture before next obs or title, too
                            let reportId = prosConnect.getObjListIdFromItemId(afterObj[ATTR_OBJ_ID])
                            let reportItems = activeProject.getReportItemsByReportId(reportId)
                            let titlePos = reportItems.findIndex(rep => rep[ATTR_OBJ_ID] === this.sourceObj[ATTR_OBJ_ID])
                            if (titlePos < 0) {
                                // should not happen
                                prosConnect.prosLogErr("title move integrity error for", this.sourceObj)
                            } else {
                                for (let afterTitlePos = titlePos+1; afterTitlePos < reportItems.length; afterTitlePos += 1) {
                                    let itm = reportItems[afterTitlePos]
                                    let itmType = itm[ATTR_OBJ_TYPE]
                                    if (itmType === OBJ_TYPE_ITM_TITLE || itmType === OBJ_TYPE_ITM_OBS) {
                                        break
                                    }
                                    // Add minimum spacing and do another update after data from server
                                    adjustSpacingAfterUpdate = true
                                    sortOrder += 1
                                    itm[ATTR_SORT_ORDER_I] = sortOrder
                                    changes.push(prosConnect.getChangeObj(itm, {[ATTR_SORT_ORDER_I]: sortOrder}))
                                }
                            }
                        } else {
                            // When moving OBS attachment to different OBS need to take parent OBS from that
                            let newParentId = getValidAttr(afterObj, ATTR_PARENT_OBS, STR_NO_VALUE)
                            if (afterObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
                                newParentId = STR_NO_VALUE
                            }
                            changedItem[ATTR_PARENT_OBS] = newParentId
                        }
                    }
                    await activeProject.awaitUpdateMultipleItemsAttributes(changes, true)
                }
            } else {
                await this.awaitMoveBetweenReports(afterObj);
            }
        }
        this.cancelOperations()
        return adjustSpacingAfterUpdate
    }

    // Copy marked (drag) sourceObj after target (drop) - return created obj
    async awaitCopy(afterObj, keepParameters=false) {
        if (!this.sourceObj) {
            this.sourceObj = getGlobalRef();
            if (this.sourceObj) {
                prosConnect.markGlobalRef(undefined);
                delete this.sourceObj[ATTR_AWS_PROJECT_ID];
                prosConnect.prosLog("GLO transfer - copy from other browser", this.sourceObj);
            }
        }
        if (!this.sourceObj) {
            prosConnect.prosLogErr("Integrity error in copying - no ref obj");
            return;
        }
        // console.log("COPY", this.sourceObj);
        // console.log("AFTER", afterObj);
        let afterObjId = afterObj[ATTR_OBJ_ID];
        let targetListId = prosConnect.getObjListIdFromItemId(afterObjId);
        let newObj = prosConnect.makeObjCopyForAws(this.sourceObj, true);
        let sortOrder = prosConnect.getActiveProject().getSortOrderAfter(newObj, afterObjId);
        let newObjId = prosConnect.makeNewObjId(targetListId);
        newObj[ATTR_OBJ_ID] = newObjId;
        newObj[ATTR_SORT_ORDER_I] = sortOrder;
        let newObjs = [newObj];
        if (prosConnect.isObservation(newObj)) {
            // console.log("copy OBS");
            for (let i in this.sourceObj.obsObjList) {
                let newItem = prosConnect.makeObjCopyForAws(this.sourceObj.obsObjList[i], true);
                sortOrder += prosConnect.DEFAULT_SORT_ORDER_SPACING;
                newItem[ATTR_SORT_ORDER_I] = sortOrder;
                newItem[ATTR_PARENT_OBS] = newObjId;
                newItem[PROS_REPLACE_BY_LIST_ID] = targetListId;
                newObjs.push(newItem);
            }
        } else if (prosConnect.isItem(newObj)){
            // console.log("copy OBJ - new obj", newObj, "after:", afterObj);
            // item - comment or picture
            if (prosConnect.isObservation(afterObj)) {
                newObj[ATTR_PARENT_OBS] = afterObjId;
                // console.log("set parent afterObj as it is obs", afterObjId)
            } else if (afterObj.hasOwnProperty(ATTR_PARENT_OBS)) {
                newObj[ATTR_PARENT_OBS] = afterObj[ATTR_PARENT_OBS];
                // console.log("set parent from items parent", newObjId)
            } else {
                // console.log("after obj does not have parent", afterObj)
            }
        }
        await prosConnect.getActiveProject().awaitUpdateMultipleItems(newObjs, true);
        if (!keepParameters) {
            this.clear();
        }
        return newObjs[0]
    }

    // Copy most of the attributes as in orginal including
    //      text
    //      sort order
    //      media file name, overlay file name
    // Just generate new created & updated info's
    // returns new report ID
    async awaitMarkedReportToActiveProject() {
        function makeNewListId(itemsObjId, newReportId) {
            let originalListId = itemsObjId.split("_")[0];
            return itemsObjId.replace(originalListId, newReportId)
        }

        if (!prosConnect.getActiveProject()) {
            return;
        }
        let originalReport = prosConnect.makeObjCopyForAws(this.sourceObj);
        let activeProject = prosConnect.getActiveProject();
        // console.log("COPY REPORT", this.sourceObj);
        // console.log("to project", activeProject.getPid());
        let newObjs = [];
        let newReport = prosConnect.makeObjCopyForAws(this.sourceObj, true);
        let newReportId = activeProject.makeNewReportId()
        newReport[ATTR_OBJ_ID] = newReportId;
        newReport[ATTR_COPY_FROM_REPORT] = this.sourcePid + '/' + this.sourceObj[ATTR_OBJ_ID];
        newReport[ATTR_SORT_ORDER_I] = currentTimeMs()
        newObjs.push(newReport);
        for (let srcItem of this.sourceReportItems) {
            let item = prosConnect.makeObjCopyForAws(srcItem, true);
            item[ATTR_OBJ_ID] = makeNewListId(srcItem[ATTR_OBJ_ID], newReportId);
            if (getValidAttr(srcItem, ATTR_PARENT_OBS, STR_NO_VALUE) !== STR_NO_VALUE) {
                item[ATTR_PARENT_OBS] = makeNewListId(srcItem[ATTR_PARENT_OBS], newReportId);
            }
            newObjs.push(item);
        }
        await activeProject.awaitUpdateMultipleItems(newObjs, true);
        if (this.isMoveMode()) {
            originalReport[ATTR_AWS_PROJECT_ID] = this.sourcePid;
            originalReport[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
            await prosConnect.getActiveProject().awaitUpdateItem(originalReport);
        }
        this.cancelOperations()
        return newReportId
    }

}
